import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddDocumentUpload from "../../Models/AddCerificates/addCertificates";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { Modal, Button } from "react-bootstrap";
import {
  GetCertificate,
  deleteCertificate,
} from "../../apis/api/CertificateApi";
import { useDispatch, useSelector } from "react-redux";
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";

const Certificates = () => {
  const navigate = useNavigate();
  const [openModel, setCloseModel] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const company_id = location.state?.company_id;
  const CookiesCompany_id = Cookies.get("company_id");

  useEffect(() => {
    if (company_id) {
      dispatch(GetCertificate({ company_id: company_id }));
    } else {
      dispatch(GetCertificate({ company_id: CookiesCompany_id }));
    }
  }, [company_id]);

  const { CertificateData, loading } = useSelector(
    (state) => state.CertificateSlice
  );

  const handleDeleteClick = (doc) => {
    setSelectedDoc(doc);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    const response = await dispatch(deleteCertificate({ id: selectedDoc.id }));
    if (response.payload.status === "success") {
      setShowDeleteModal(false);
      dispatch(GetCertificate({ company_id: CookiesCompany_id }));
      toast.success("Document deleted successfully.");
    } else {
      setShowDeleteModal(false);
      toast.error("Error deleting document.");
    }
  };

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "certificate";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Unable to download file.");
    }
  };

  return (
    <>
      {loading && <Lodderr />}

      <AddDocumentUpload
        show={openModel}
        handleClose={() => setCloseModel(false)}
      />

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete <strong>{selectedDoc?.name}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <div
        className="bg-white shadow rounded"
        style={{ height: "80vh", overflowY: "auto" }}
      >
        <div className="d-flex justify-content-between m-3">
          {company_id == CookiesCompany_id && (
            <button
              className="btn btn-secondary bg-theme-color btn-sm mt-3"
              onClick={() => setCloseModel(true)}
            >
              <i className="bx bx-edit"></i> Add Certificate
            </button>
          )}
          {/* <button className="btn btn-sm btn-secondary" onClick={() => navigate(-1)}>
          <i className="bx bx-left-arrow-alt"></i>
          Back
        </button> */}
        </div>

        {CertificateData?.result && CertificateData.result.length > 0 ? (
          <div className="container-fluid mb-3 w-100 p-4 ">
            {/* <div className="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-file-alt me-1"></i>
                <h4 className="fw-bold text-theme mb-0">Certificates</h4>
              </div>
            </div> */}

            <div className="row">
              {CertificateData.result.map((cert, index) => {
                const cleanUrl = cert.file_url.replace("thumb/", "");

                return (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                  >
                    <div
                      className="card h-100 shadow-sm  transition"
                      style={{
                        transition: "transform 0.2s, box-shadow 0.2s",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-5px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0px)")
                      }
                    >
                      <div
                        className="card-img-top text-center bg-light p-3"
                        style={{ height: "180px" }}
                      >
                        <img
                          src={cert.file_url}
                          alt={cert.file_name}
                          className="img-fluid rounded"
                          style={{ maxHeight: "140px", objectFit: "cover" }}
                        />
                      </div>
                      <div className="card-body">
                        <h6
                          className="card-title text-truncate"
                          title={cert.file_name}
                        >
                          {cert.title || cert.file_name}
                        </h6>
                        <p className="text-muted small mb-2">
                          Uploaded:{" "}
                          {new Date(
                            cert.created_at * 1000
                          ).toLocaleDateString()}
                        </p>
                        <div className="d-flex justify-content-between">
                          <a
                            href={cleanUrl}
                            className="btn btn-sm btn-outline-warning me-2"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="View"
                          >
                            <i className="bx bx-show"></i>
                          </a>
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() =>
                              handleDownload(cleanUrl, cert.title)
                            }
                            title="Download"
                          >
                            <i className="bx bx-download"></i>
                          </button>

                          {company_id == CookiesCompany_id && (
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteClick(cert)}
                              title="Delete"
                            >
                              <i className="bx bx-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <p className="text-center fs-4 ">No certificates available.</p>
        )}
      </div>
    </>
  );
};

export default Certificates;
